// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetMarketTrandResponseSchema } from '../../entities/market_trand/GetMarketTrandResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';
import type { FetchModelResponse, FetchModelResponseToIModelResponse, IFetchModel } from '@cian/http-api';

export interface IGetMarketTrandRequest {
  period: EQueryParameters;
  realtyId: number;
  roomsCount: EQueryParameters_1;
}

export enum EQueryParameters {
  /** Все вермя **/
  'All' = 'all',
  /** 1 месяц **/
  'OneMonth' = 'oneMonth',
  /** 1 год **/
  'OneYear' = 'oneYear',
  /** 6 месяцев **/
  'SixMonths' = 'sixMonths',
  /** 2 года **/
  'TwoYears' = 'twoYears',
}
export enum EQueryParameters_1 {
  /** Все квартиры **/
  'All' = 'all',
  /** Четырехкомнатная квартира + другие **/
  'FourPlusRooms' = 'fourPlusRooms',
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Студия **/
  'Studio' = 'studio',
  /** Трехкомнатная квартира **/
  'ThreeRooms' = 'threeRooms',
  /** Двухкомнатная квартира **/
  'TwoRooms' = 'twoRooms',
}
export type TGetMarketTrandResponse_1 = IGetMarketTrandResponseSchema;

export type TGetMarketTrandResponseError = IErrorResponseSchema;

export type IGetMarketTrandResponse200 = FetchModelResponse<200, 'json', TGetMarketTrandResponse_1>;

export type IGetMarketTrandResponse400 = FetchModelResponse<400, 'json', TGetMarketTrandResponseError>;

export type TGetMarketTrandResponse_ = IGetMarketTrandResponse200 | IGetMarketTrandResponse400;

export type TGetMarketTrandResponse = FetchModelResponseToIModelResponse<TGetMarketTrandResponse_>;

export type TGetMarketTrandModel = IFetchModel<IGetMarketTrandRequest, undefined, TGetMarketTrandResponse_>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: TGetMarketTrandResponse_1, headers: Headers): TResponse200;
  400(response: TGetMarketTrandResponseError, headers: Headers): TResponse400;
}
